import * as React from 'react';
import { Field } from 'redux-form';
import { II18nMessages } from '../../../../../../services/branding/models';
import { Button, Col, ControlLabel, FormGroup, Row } from 'react-bootstrap';
import SelectControl from '../../../../../../components/SelectControl';
import { FaTrash }  from 'react-icons/fa';
import { IDestination } from '../../../../../../data/api/models';
import { isRequired } from '../../../../../../util/validators';
import { filter } from 'lodash';

interface ITripDetailsForm {
  i18n: II18nMessages;
  destinations: IDestination[];
  destinationsValue: string[];
  pristine: boolean;
  fields: any;
}

class Destination extends React.Component<ITripDetailsForm> {
  private addField = () => {
    const { fields } = this.props;

    fields.push('');
  }

  private deleteField = (index) => () => {
    const { fields } = this.props;

    fields.remove(index);
  }

  private renderFields() {
    const { fields, destinations, destinationsValue } = this.props;

    const destinationsListFiltered = filter(destinations, (destination) => destination.included === true);

    const destinationsList = destinationsListFiltered.map((destination) => ({
      label: destination.name,
      value: destination.name,
      disabled: destinationsValue.indexOf(destination.name) > -1,
    }));

    return fields.map((destination, index) => {
      const columns = {
        first: {
          field: {
            xs: 12,
          },
          btn: {
            xs: 0,
            className: 'hidden',
          },
        },
        normal: {
          field: {
            xs: 10,
            sm: 8,
            md: 9,
            lg: 10,
          },
          btn: {
            xs: 2,
            sm: 4,
            md: 3,
            lg: 2,
          },
        },
      };
      const colConfig = columns[index === 0 ? 'first' : 'normal'];

      return (
        <Row key={index}>
          <Col {...colConfig.field}>
            <Field
              name={destination}
              options={destinationsList}
              component={SelectControl}
              validate={[isRequired]}
              clearable={false}
            />
          </Col>
          <Col {...colConfig.btn}>
            <Button bsStyle="link" onClick={this.deleteField(index)}>
              <FaTrash />
            </Button>
          </Col>
        </Row>
      );
    });
  }

  public render() {
    const { i18n, fields } = this.props;

    if (fields.length === 0) {
      this.addField();
    }

    return (
      <div className="section">
        {i18n.quote.tripDetails.destinations}
        <Row className="margin-top">
          <Col sm={12}>
            <FormGroup controlId="destination">
              <Col componentClass={ControlLabel} sm={3}>
                {i18n.quote.tripDetails.destination}
              </Col>
              <Col sm={9} className="destinations-inputs">
                {this.renderFields()}
              </Col>
            </FormGroup>
          </Col>
        </Row>
        <Button bsStyle="primary" onClick={this.addField}>
          {i18n.quote.tripDetails.addCountry}
        </Button>
      </div>
    );
  }
}

export default Destination;
